import { postMainApi, putMainApi } from "@Shared/utils/ajax";
export const handleChat = async payload => {
  try {
    return await postMainApi(payload, `/chat`);
  } catch (error) {
    return {
      message: "Oops! I've hit a glitch and can't assist at the moment. Please try again later or contact support. Thanks for understanding!",
      localUser: false
    };
  }
};
export const updateChatInteraction = async payload => {
  try {
    await putMainApi(payload, `/chat/interaction/${payload.interactionId}`);
  } catch (error) {
    console.error(error);
  }
};